import React from "react";

export const profileUrl = "https://me.deets.digital";
